import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  tabTitle: string = 'Manage Commission';

  constructor(public matMenu: MatMenuModule, public router: Router) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
  }


  retailerPricelistSelected() {
    this.tabTitle = 'Retailer pricelist';
  }
  salesRepListSelected() {
    this.tabTitle = 'Sales Rep/Dist pricelist';
  }


  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // console.log('index => ', tabChangeEvent.index);
    if (tabChangeEvent.index != 1) {
      this.tabTitle = 'Manage Commission';
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
